export default __webpack_public_path__ + "static/media/Logo.7c2ff2cf.svg";